/** @file The pattern of node and variant names an agent gives (no `.` or `-`, which flattening uses). */

/** A letter or `_`, then letters, digits or `_`. */
export const USER_NAME_PATTERN = /^[A-Za-z_][A-Za-z0-9_]*$/;
